<template>
  <div class="body">
    <div class="mb-8" v-if="heroData">
      <Hero :data="heroData"/>
    </div>

    <div class="content-container">
      <div class="mb-28" v-if="descriptionData">
        <Description :data="descriptionData"/>
      </div>
      <div class="mb-44" v-if="programData">
        <Program :data="programData"/>
      </div>
      <div class="mb-40" v-if="contactsData">
        <Contacts :data="contactsData"/>
      </div>
      <div class="mb-44" v-if="videoData">
        <VideoBlock :data="videoData"/>
      </div>
    </div>
  </div>
</template>

<script>
import Hero from '@/components/Hero/Hero.vue';
import Description from '@/components/Description/Description.vue';
import Program from '@/components/Program/Program.vue';
import Contacts from '@/components/Contacts/Contacts.vue';
import VideoBlock from '@/components/VideoBlock/VideoBlock.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'Body',
  components: {
    Description,
    VideoBlock,
    Contacts,
    Program,
    Hero,
  },
  computed: {
    ...mapGetters({
      heroData: 'app/getHeroData',
      descriptionData: 'app/getDescriptionData',
      programData: 'app/getProgramData',
      contactsData: 'app/getContactsData',
      videoData: 'app/getPodcastData',
    }),
  },
  mounted() {
    document.body.classList.remove('lock');
  },
  beforeUnmount() {
    document.body.classList.add('lock');
  },
};
</script>

<style lang="scss" scoped>
@import "Body";
</style>
